import styled from "@emotion/styled";

export const SheetTitleContainer = styled.div`
  display: flex;
  align-items: center;

  button {
    opacity: 0;
    transition: opacity 0.2s ease-in-out;
  }

  &:hover {
    button {
      opacity: 1;
    }
  }
`;


export const DataTableStyles = styled.div`
  width: 100%;

  .tableWrap {
    display: block;
    max-width: 100%;
    overflow-x: scroll;
    overflow-y: hidden;
    border-bottom: 1px solid black;
  }

  .table {
    width: 100%;
    border-spacing: 0;
    display: inline-block;
    border-top: 1px solid rgba(144, 164, 183, 0.22);

    .th {
      cursor: pointer;
      font-weight: 600;
      padding: 0.5rem;
      transition: background-color 0.2s ease-in-out;

      &:hover {
        background-color: #f7fafc;
      }

      &:last-of-type {
        &:hover {
          background-color: transparent;
        }
      }
    }

    .tr {
      :last-child {
        .td {
          border-bottom: 0;
        }
      }
    }

    .th, .td {
      margin: 0;
      font-size: 14px;
      border-bottom: 1px solid rgba(144, 164, 183, 0.22);
      border-right: 1px solid rgba(144, 164, 183, 0.22);

      .input {
        margin: 0;
        border: 0;
        height: 100%;
        outline: none;
        font-weight: 400;
        font-size: 0.875rem;
        padding: 0.25rem 0.5rem;
      }
    }
  }
`;